<div class="input-group input-group-datepicker {{ groupClass }}">
	<input
		#input
		type="text"
		class="form-control {{ inputClass }}"
		[class.is-invalid]="control.dirty && control.invalid"
		[id]="controlId"
		placeholder="{{ 'Formats.Date.Base.Placeholder' | translate }}"
		bsDatepicker
		[isDisabled]="isDisabled"
		[daysDisabled]="daysDisabled"
		[disabled]="isDisabled"
		[bsValue]="innerValue"
		[bsConfig]="bsConfig"
		(bsValueChange)="writeValue($event)"
		#dp="bsDatepicker"
		[maxDate]="maxDate"
		[minDate]="minDate"
		[placement]="placement"
		autocomplete="off"
		inputRestriction="date"
	/>
	<div class="input-group-append">
		<span class="input-group-text input-datepicker" [class.disabled]="isDisabled" (click)="!isDisabled ? dp.show() : ''"><i class="far fa-calendar-alt"></i></span>
	</div>
</div>